import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiClientService } from '../../core/api/api-client.service';

@Component({
  selector: 'app-forgot-password-page',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './forgot-password-page.component.html'
})
export class ForgotPasswordPageComponent {
  private readonly api = inject(ApiClientService);

  protected readonly form = new FormGroup({
    email: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] })
  });
  protected readonly submitted = signal(false);
  protected readonly loading = signal(false);
  protected readonly message = signal<string | null>(null);
  protected readonly resetUrl = signal<string | null>(null);

  submit(): void {
    this.submitted.set(true);

    if (this.form.invalid || this.loading()) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading.set(true);
    this.message.set(null);
    this.resetUrl.set(null);

    this.api.requestPasswordReset(this.form.getRawValue()).subscribe({
      next: (response) => {
        this.message.set(response.message);
        this.resetUrl.set(response.resetUrl);
      },
      error: () => {
        this.message.set('Der Passwort-Link konnte nicht erstellt werden.');
      },
      complete: () => this.loading.set(false)
    });
  }
}
